<script>
	import {onMount} from "svelte";
	import { NotificationDisplay, notifier } from '@beyonk/svelte-notifications'

	import {navigate} from './Navigation/Routes.svelte';
	import {routes} from './Navigation/routes.js';
	import Router from 'svelte-spa-router';

	let currentRoute;

	import Login, {logOut, checkLoggedIn} from './Users/Login.svelte';

	import {session} from './Utilities/Session.svelte'

	let NotificationTimeout = 3000;

	onMount(() => {
		checkLoggedIn()
		navigate("AssessmentList")
	})
</script>

<style>
	:global(.pointer) {
		cursor: pointer;
	}

	.logo {
		max-height: 3em;
	}
</style>

{#if $session.loggedIn}

<nav class="navbar" role="navigation" aria-label="main navigation">
	<div class="navbar-brand">
		<a class="navbar-item" href="/">
			<img class="logo" alt="Kroll" src="assets/Kroll_DP_Logo.png">
		</a>
	</div>
	<div class="navbar-menu">
		<div class="navbar-start">
			<a href="#/assessments/" class="navbar-item">
				Assessments
			</a>
			<a href="#/assessmentTypes/" class="navbar-item">
				Assessment Types
			</a>
			<a href="#/nessus/" class="navbar-item">
				Nessus Report Generator
			</a>
		</div>
		<div class="navbar-end">
			<div class="navbar-item has-dropdown is-hoverable">
        		<span class="navbar-link is-arrowless has-icon">
					<span>{$session.user.name}</span>
					<span class="icon">
						<i class="fas fa-cog"></i>
					</span>
				</span>
				 <div class="navbar-dropdown is-right is-boxed">
          			<a class="navbar-item" href="#/auth/users/">
            			Manage Users
          			</a>
					<a href="#/snippets/" class="navbar-item">
						Manage Snippets
					</a>
					<a href="#/transforms/" class="navbar-item">
						Manage Transforms
					</a>
					<a href="#/findings/templates/" class="navbar-item">
						Manage Findings Tables
					</a>
					<span class="link navbar-item pointer" on:click={logOut}>
            			Log Out
          			</span>
			</div>
		</div>
	</div>
</nav>


<section class="section">
	<NotificationDisplay timeout={NotificationTimeout} />

	<div class="container is-fluid">
		<Router {routes} />
	</div>
</section>
{:else}
	<Login />
{/if}